module.exports = __webpack_public_path__ + "img/hudson-valley.0ade2ba.jpg";